<template>
    <v-bottom-sheet
        v-model="sheet"
        inset
        persistent
    >
        <ListingModel :module="module"/>
    </v-bottom-sheet>
</template>


<script>
import {ref} from "vue";
import ListingModel from "@/views/Edms/Document/Components/ListingModel.vue";

export default {
    name: "ModuleDocuments",
    components: {ListingModel},
    props: {
        module: String,
    },
    setup() {
        const sheet = ref(true);

        return {sheet};
    }
}
</script>

<style scoped>

</style>